import { sendGA4Event } from "../utils/tracking";
import React, { Component } from "react";
import axios from "axios";
import LoaderPanel from "../components/LoaderPanel";
import LoaderButton from "../components/LoaderButton";
import withLoadSave from "../components/LoadSave";
import { FormControlLabel } from "../components/FormControls";
import SaveNavbar from "../components/SaveNavbar";
import { EDFormSection, EDFormBox } from "../components/EDDOM";
import getvalue from "../utils/getvalue";

class SparkPostEdit extends Component {
  handleChange = event => {
    this.props.update({[event.target.id]: {$set: getvalue(event)}})
  }

  handleSubmit = async event => {
    var isclose = this.props.formClose(event);

    var id = (await this.props.save()).data.id;

    if (isclose) {
      this.goBack();
    } else {
      this.props.history.replace("/sparkpost/edit?id=" + id);
    }
  }

  goBack = () => {
    this.props.history.push("/sparkpost");
  }

  navbarButtons = () => {
    return (
      <LoaderButton
        id="server-buttons-dropdown"
        text="Save and Close"
        loadingText="Saving..."
        className="green"
        disabled={this.props.isSaving}
        onClick={() => {
          sendGA4Event('Connections', 'SparkPost', 'Saved SparkPost Configuration');
          return this.props.formSubmit(true);
        }}
        splitItems={[
          { text: 'Save', onClick: () => { sendGA4Event('Connections', 'SparkPost', 'Saved SparkPost Configuration'); return this.props.formSubmit(); } },
          { text: 'Cancel', onClick: this.goBack }
        ]}
      />
    )
  }

  render() {
    var dataName = this.props.data && (this.props.data.name || '');
    var title = `${this.props.id === 'new'?'Add SparkPost Account':`Edit SparkPost Account ${dataName ? `for "${dataName}"` : ''}`}`;

    return (
      <LoaderPanel isLoading={this.props.isLoading}>
        <SaveNavbar isAdmin={true} title={title} onBack={this.goBack} buttons={this.navbarButtons()} id={this.props.id}>
          <EDFormSection onSubmit={this.handleSubmit} formRef={this.props.formRef}>
            <EDFormBox>
              <FormControlLabel
                id="name"
                label="Name"
                obj={this.props.data}
                onChange={this.handleChange}
                required={true}
              />
              <FormControlLabel
                id="apikey"
                label="API Key"
                obj={this.props.data}
                onChange={this.handleChange}
                required={true}
                type="password"
                space
              />
              <FormControlLabel
                id="linkdomain"
                label="Message Body Link Domain"
                help="Example: link.domain.com (no http:// or https://)"
                obj={this.props.data}
                onChange={this.handleChange}
                space
              />
            </EDFormBox>
          </EDFormSection>
        </SaveNavbar>
      </LoaderPanel>
    );
  }
}

export default withLoadSave({
  extend: SparkPostEdit,
  initial: { name: '', apikey: '', linkdomain: '' },
  get: async ({id}) => (await axios.get('/api/sparkpost/' + id)).data,
  post: ({data}) => axios.post('/api/sparkpost', data),
  patch: ({id, data}) => axios.patch('/api/sparkpost/' + id, data),
});



// WEBPACK FOOTER //
// ./src/containers/SparkPostEdit.js